import { createSelector } from 'reselect';
import { appStateSelector } from './baseSelectors';

const navigationTimeStampSelector = createSelector(appStateSelector, appState => appState.navigationTimeStamp || 0);

export default navigationTimeStampSelector;
